module.exports = __webpack_public_path__ + "img/banner1.3fb01d98.png";